import { css } from 'styled-components';
export const newListItemStyles = css(["@media screen and (max-width:554px){display:none;}"]);